import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';

import { ApiService } from '../services/api.service';

export const VIEW_GUARD: CanActivateFn = () => {
  const API_SERVICE = inject(ApiService);
  const ROUTER = inject(Router);

  if (!API_SERVICE.isLoggedIn()) {
    ROUTER.navigate(['/']);
    return false;
  }
  return true;
};
